import { useState } from 'react'

import { MembersDropdown } from '../../../../../components/shared/members-dropdown'
import type { UserDetails } from '../../../../../types/user'
import { TeamMemberSelection } from './team-member-selection'

interface IShipmentTeamMembers {
  selectedUsers: UserDetails[]
  shipmentID: string
  workspaceID: string
}

/**
 * This component is used to display a dropdown to select team members for a shipment.
 * It allows the user to search for and select team members from the workspace.
 */
export const ShipmentTeamMembers = ({ selectedUsers, workspaceID, shipmentID }: IShipmentTeamMembers) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenChange = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="relative w-full">
      <MembersDropdown
        isOpen={isOpen}
        handleOpenChange={handleOpenChange}
        buttonText={'Add Team Members'}
        selectedUsersAvatar={selectedUsers}
        popoverContent={
          <TeamMemberSelection selectedUsers={selectedUsers} workspaceID={workspaceID} shipmentID={shipmentID} />
        }
      />
    </div>
  )
}
